namespace TotalPoll {
    import Component = TotalCore.Common.Component;

    @Component('components.totalpoll', {
        templateUrl: 'finish-component-template',
        bindings: {}
    })
    class FinishComponent {

        public constructor(private $scope, public OnBoarding) {

        }
    }
}
